export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./geral.vue?vue&type=template&id=16e9e493&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/consulta-nfe/geral.vue?vue&type=template&id=16e9e493&scoped=true&
// module id = 267
// module chunks = 1